function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import sha256 from 'crypto-js/sha256';
import { getWindow } from '@shared/services/window';
import { getSpzaUserIdAndNewUserModifier, getTrailIdAndData } from '@shared/utils/appUtils';
import { Constants } from '@shared/utils/constants';
const OneDSEventNames = {
    ClientError: 'Ms.Web.ClientError'
};
const getCommonData = ()=>{
    var _initialConfiguration_siteEnvironment, _initialConfiguration_query, _getTrailIdAndData, _getWindow_navigator, _getWindow_location, _getWindow_navigator_connection, _getWindow_navigator1;
    const initialConfiguration = getWindow().__INITIAL_STATE__.config;
    return {
        environment: ((_initialConfiguration_siteEnvironment = initialConfiguration.siteEnvironment) === null || _initialConfiguration_siteEnvironment === void 0 ? void 0 : _initialConfiguration_siteEnvironment.toLowerCase()) || '',
        appVersion: initialConfiguration.appVersion || '',
        region: initialConfiguration.region || '',
        spzaId: getSpzaUserIdAndNewUserModifier().spzaUserId || '',
        hostType: !initialConfiguration.isEmbedded ? Constants.appSource : Constants.appSourceEmbed,
        locale: ((_initialConfiguration_query = initialConfiguration.query) === null || _initialConfiguration_query === void 0 ? void 0 : _initialConfiguration_query.locale) || '',
        correlationId: initialConfiguration.correlationId || Constants.ReservedCorrelationIds.EmptyId,
        mshash: ((_getTrailIdAndData = getTrailIdAndData()) === null || _getTrailIdAndData === void 0 ? void 0 : _getTrailIdAndData.trailId) || '',
        userAgent: ((_getWindow_navigator = getWindow().navigator) === null || _getWindow_navigator === void 0 ? void 0 : _getWindow_navigator.userAgent) || '',
        host: ((_getWindow_location = getWindow().location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.host) || '',
        landingView: initialConfiguration.landingView || '',
        connectionEffectiveType: ((_getWindow_navigator1 = getWindow().navigator) === null || _getWindow_navigator1 === void 0 ? void 0 : (_getWindow_navigator_connection = _getWindow_navigator1.connection) === null || _getWindow_navigator_connection === void 0 ? void 0 : _getWindow_navigator_connection.effectiveType) || ''
    };
};
export class Logger {
    modifyClientError(item) {
        if (item.name !== OneDSEventNames.ClientError) {
            return;
        }
        if (Array.isArray(item.baseData.exceptions)) {
            item.baseData.exceptions = JSON.stringify(item.baseData.exceptions);
        }
        if (Array.isArray(item.tags)) {
            delete item.tags;
        }
    }
    get logger() {
        return this._1dsLogger;
    }
    initialize(_1dsLogger, store) {
        this._1dsLogger = _1dsLogger;
        this.store = store;
        this.logMetadata = getCommonData();
        this._1dsLogger.addTelemetryInitializer(this.modifyClientError);
        Object.entries(this.logMetadata).forEach(([key, value])=>{
            this._1dsLogger.getPropertyManager().setProperty(key, value);
        });
        // Flush preload events - if any
        Promise.resolve().then(()=>this.preLoadEvents.forEach(({ level, collection, payload })=>this.log(level, collection, payload)));
    }
    log(level, collection, loggerPayload) {
        if (this._1dsLogger && this.logMetadata) {
            try {
                var _this_store, _state_modal, _state_checkout_items_, _state_checkout_items, _state_checkout, _getWindow_navigator, _getWindow, _getWindow_navigator1, _getWindow1, _getWindow_location, _getWindow2, _getWindow3, _this__1dsLogger;
                const state = (_this_store = this.store) === null || _this_store === void 0 ? void 0 : _this_store.getState();
                const { oid, tid, signedIn, isMSAUser, userSegment } = (state === null || state === void 0 ? void 0 : state.users) || {};
                const { config: { featureFlags } } = state;
                const hashedOid = oid ? sha256(oid).toString().toLowerCase() : '';
                const appName = loggerPayload.appName ? loggerPayload.appName : (state === null || state === void 0 ? void 0 : (_state_modal = state.modal) === null || _state_modal === void 0 ? void 0 : _state_modal.entityId) || ((_state_checkout = state.checkout) === null || _state_checkout === void 0 ? void 0 : (_state_checkout_items = _state_checkout.items) === null || _state_checkout_items === void 0 ? void 0 : (_state_checkout_items_ = _state_checkout_items[0]) === null || _state_checkout_items_ === void 0 ? void 0 : _state_checkout_items_.entityId) || '';
                const data = _object_spread_props(_object_spread({}, loggerPayload), {
                    browserLanguage: ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_navigator = _getWindow.navigator) === null || _getWindow_navigator === void 0 ? void 0 : _getWindow_navigator.language) || ((_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : (_getWindow_navigator1 = _getWindow1.navigator) === null || _getWindow_navigator1 === void 0 ? void 0 : _getWindow_navigator1.userLanguage) || '',
                    page: loggerPayload.page || ((_getWindow2 = getWindow()) === null || _getWindow2 === void 0 ? void 0 : (_getWindow_location = _getWindow2.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href) || '',
                    embed: `${((_getWindow3 = getWindow()) === null || _getWindow3 === void 0 ? void 0 : _getWindow3.AppsourceMode) === 'Embed'}`,
                    duration: loggerPayload.duration || -1,
                    clientTimestamp: new Date().toISOString(),
                    hashedOid,
                    tid: tid || '',
                    isLoggedIn: `${!!signedIn}`,
                    isMSA: `${!!isMSAUser}`,
                    accountType: userSegment || '',
                    collection,
                    level,
                    appName
                });
                (_this__1dsLogger = this._1dsLogger) === null || _this__1dsLogger === void 0 ? void 0 : _this__1dsLogger.trackEvent({
                    name: `${this.logMetadata.environment.toUpperCase()}.${collection}`
                }, data);
                if (featureFlags.logToConsole) {
                    console.log(JSON.stringify(data));
                }
            } catch (e) {}
        } else {
            this.preLoadEvents.push({
                level,
                collection,
                payload: loggerPayload
            });
        }
    }
    flush() {
        this._1dsLogger.getPostChannel().flush(false);
    }
    constructor(){
        _define_property(this, "_1dsLogger", void 0);
        _define_property(this, "logMetadata", void 0);
        _define_property(this, "store", void 0);
        _define_property(this, "preLoadEvents", []);
    }
}
